import { CtaLayout1Theme } from '@components/cta/components/cta-layout-1/enum';
import { CtaLayout1Style } from '@components/cta/components/cta-layout-1/model';

export const ctaLayout1Style: { [key: string]: CtaLayout1Style } = {
  [CtaLayout1Theme.CREAM]: {
    backgroundColor: 'CREAM',
    textColor: 'BLACK',
    cta: {
      icon: {
        name: 'CHEVRON_RIGHT',
        position: 'RIGHT',
        color: 'BLACK',
      },
      size: 'LARGE',
      theme: 'TRANSPARENT_BLACK',
    },
  },
  [CtaLayout1Theme.RED]: {
    backgroundColor: 'RED',
    textColor: 'WHITE',
    cta: {
      icon: {
        name: 'CHEVRON_RIGHT',
        position: 'RIGHT',
        color: 'WHITE',
      },
      size: 'LARGE',
      theme: 'TRANSPARENT_WHITE',
    },
  },
  [CtaLayout1Theme.WHITE]: {
    backgroundColor: 'WHITE',
    textColor: 'BLACK',
    cta: {
      icon: {
        name: 'CHEVRON_RIGHT',
        position: 'RIGHT',
        color: 'BLACK',
      },
      size: 'LARGE',
      theme: 'TRANSPARENT_BLACK',
    },
  },
};
